/** Space between the composer and an open keyboard, in place of the home-indicator inset. */
const KEYBOARD_GAP = 10;

/** Space between the floating composer and the tab bar it rides above. */
const FLOATING_BOTTOM_GAP = 8;

/** The least padding under a native composer, so it never touches the screen's edge. */
const MIN_NATIVE_PADDING = 12;

/** Padding under the composer on web, which has no safe area to clear. */
const WEB_PADDING = 8;

type DockPaddingInput = {
  isNative: boolean;
  isKeyboardVisible: boolean;
  /** Whether the composer floats over the thread on glass instead of sitting below it. */
  isDockFloating: boolean;
  /** The bottom safe-area inset, which inside a native tab includes the tab bar. */
  bottomInset: number;
};

/**
 * The padding under the support thread's composer. A floating composer sits above
 * the tab bar and so adds a gap there; with the keyboard open the inset is
 * replaced by a small gap, since the keyboard covers the tab bar.
 */
export function getDockPaddingBottom({
  isNative,
  isKeyboardVisible,
  isDockFloating,
  bottomInset,
}: DockPaddingInput): number {
  if (!isNative) {
    return WEB_PADDING;
  }

  if (isKeyboardVisible) {
    return KEYBOARD_GAP;
  }

  return Math.max(bottomInset + (isDockFloating ? FLOATING_BOTTOM_GAP : 0), MIN_NATIVE_PADDING);
}
